import { meSchema } from '@pickpro/contracts';
import { z } from 'zod';

const SESSION_CHANNEL = 'pickpro:session';

const sessionMessageSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('signed-in'), user: meSchema }),
  z.object({ type: z.literal('signed-out') }),
]);

export type SessionMessage = z.infer<typeof sessionMessageSchema>;
type SessionListener = (message: SessionMessage) => void;

let channel: BroadcastChannel | null = null;
const listeners = new Set<SessionListener>();

const openChannel = (): BroadcastChannel | null => {
  if (channel) return channel;
  if (typeof BroadcastChannel === 'undefined') return null;
  channel = new BroadcastChannel(SESSION_CHANNEL);
  channel.onmessage = (event: MessageEvent) => {
    const parsed = sessionMessageSchema.safeParse(event.data);
    if (!parsed.success) return;
    for (const listener of listeners) listener(parsed.data);
  };
  return channel;
};

export const publishSessionChange = (message: SessionMessage): void => {
  try {
    openChannel()?.postMessage(message);
  } catch {
    return;
  }
};

export const subscribeSessionChanges = (listener: SessionListener): (() => void) => {
  openChannel();
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
    if (listeners.size > 0 || !channel) return;
    channel.close();
    channel = null;
  };
};
